import React, { Component, Fragment } from "react";

import Select from "react-select";
import "./ProductData.css";

import { isFloat, required, length } from "../../../util/validators";

const dataTheme = ["سایز", "رنگ", "بدون رنگ یا سایز"];

const dataThemeInfo = [
  "تنوع سایز برای کالاهایی استفاده می‌شود که ظاهر مشابه دارند اما در سایزهای مختلف فروخته می‌شوند. از این تنوع برای درج کالاهایی مثل انواع لباس استفاده می‌شود. لباس‌ها ظاهری یکسان دارند اما بر اساس سایز طبقه‌بندی می‌شوند و قرار دادن آن‌ها در یک محصول می‌تواند فرآیند انتخاب را برای خریدار ساده‌تر کند.",
  "تنوع رنگ برای کالاهایی استفاده می‌شود که ظاهر مشابه دارند اما در رنگ‌های مختلف فروخته می‌شوند. از این تنوع برای کالاهایی مثل گوشی موبایل استفاده می‌شود که طبقه‌بندی و فروش آن‌ها با استفاده از رنگ‌های مختلف ساده‌تر است. توجه داشته باشید که می‌توانید برای هر رنگ، قیمتی متفاوت درج کنید. ",
  "این تنوع برای کالاهایی استفاده می‌شود که طبقه‌بندی آن‌ها بر اساس رنگ یا سایز امکان‌پذیر نیست. تنوع بدون و رنگ سایز به خریداران کمک می‌کند تا متوجه باشند دقیقا همان کالایی که در تصویر مشاهده می‌کنند، به دست‌شان می‌رسد.",
];

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

const origin = [
  { value: "1", label: "ایرانی" },
  { value: "0", label: "خارجی" },
];

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  theme: (styles) => ({ ...styles, borderRadius: "8px" }),
};
 
class ProductData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focusPositive: false,
      focusNegetive: false,

      productIsFake: false,
      selectedOrigin: "",

      description: "",
      wordCount: 0,
      positiveValue: "",
      negetiveValue: "",
      positiveValues: [],
      negetiveValues: [],
      

      productForm: {
        selectedBrand: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required],
        },
        selectedType: {
          value: [],
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required],
        },
        model: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, length({ min: 2 })],
        },
        selectedDivision: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required],
        },
        persianTitle: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, length({ min: 2 })],
        },
        englishTitle: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, length({ min: 2 })],
        },
        package_length: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        package_width: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        package_height: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        package_weight: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
      },

      brandOptions: [],
      typeOptions: [],
      divisionOptions: [],

      formIsValid: false,

      // selectedBrand: "",///
      // selectedType: [],///
      // model: "",////
      // selectedDivision: "",////
      // persianTitle: "",///
      // englishTitle: "",///
      // package_length: "",///
      // package_width: "",///
      // package_height: "",///
      // package_weight: "",///
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFocusClick = this.handleBlur.bind(this);
    this.handleFocusClick = this.handleFocus.bind(this);
    this.addPositiveHandler = this.addPositiveHandler.bind(this);
    this.addNegetiveHandler = this.addNegetiveHandler.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.productFormHandler = this.productFormHandler.bind(this);
    this.inputSelectChangeHandler = this.inputSelectChangeHandler.bind(this);
    this.inputChangeHandler = this.inputChangeHandler.bind(this);

    this.positiveTagRemoveHandler = this.positiveTagRemoveHandler.bind(this);
    this.negetiveTagRemoveHandler = this.negetiveTagRemoveHandler.bind(this);
  }
  
  componentDidUpdate(previousProps, previousState) {
    if (previousProps.categoryData !== this.props.categoryData) {
      this.FetchBrands(this.props.categoryData.code);
      this.FetchDivisions(this.props.categoryData.code);
      this.FetchTypes(this.props.categoryData.code);
      this.setState({
        productIsFake: this.props.productData.fake,
        selectedOrigin: this.props.productData.isIranian ? { value: "1", label: "ایرانی" } : { value: "0", label: "خارجی" },

        description: this.props.productData.description,
        wordCount: this.props.productData.description.trim().length,
      
        positiveValues: this.props.advantages.map(advantage => advantage.title),
        negetiveValues: this.props.disadvantages.map(disadvantage => disadvantage.title),

        formIsValid: true
      });
      
        // productData: this.props.productData,
        
        // brand: resData.data.productDetail.brand,
        // division: resData.data.productDetail.division,
        // types: resData.data.productDetail.types,
    }
    if (previousProps.productData !== this.props.productData) {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.productForm };
        for (const inputName in prevState.productForm) {
          // if (inputName === "selectedType") {
          //   for (const type of this.props.types) {
          //     updatedForm = {
          //       ...updatedForm,
          //       [inputName]: {
          //         ...updatedForm[inputName],
          //         value: prevState.productForm[inputName].value.push(this.state.typeOptions.find(element => element.value === type.code)),
          //         valid: true,
          //       },
          //     };
          //   }
          // } else 
          if( inputName !== "selectedBrand" && inputName !== "selectedDivision" && inputName !== "selectedType"){
            updatedForm = {
              ...updatedForm,
              [inputName]: {
                ...updatedForm[inputName],
                value: this.props.productData[inputName],
                valid: true,
              },
            };
          }
        }
        return {
          productForm: updatedForm,
        };
      });
    }

    if (previousState.divisionOptions !== this.state.divisionOptions) {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.productForm };        
        updatedForm = {
          ...updatedForm,
          ["selectedDivision"]: {
            ...updatedForm["selectedDivision"],
            value: this.state.divisionOptions.find(element => element.value === this.props.division.code) ,
            valid: true,
          },
        };          
        return {
          productForm: updatedForm,
        };
      });
    }

    if (previousState.brandOptions !== this.state.brandOptions) {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.productForm };
        updatedForm = {
          ...updatedForm,
          ["selectedBrand"]: {
            ...updatedForm["selectedBrand"],
            value: this.state.brandOptions.find(element => element.value === this.props.brand.code),
            valid: true,
          },
        };          
        return {
          productForm: updatedForm,
        };
      });
    }


    if (previousState.typeOptions !== this.state.typeOptions) {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.productForm };
        let prevSelectedType = prevState.productForm["selectedType"].value;
        for (const type of this.props.types) {
          prevSelectedType = [...prevSelectedType, this.state.typeOptions.find(element => element.value === type.code)];
        }
        updatedForm = {
          ...updatedForm,
          ["selectedType"]: {
            ...updatedForm["selectedType"],
            value: prevSelectedType,
            valid: true,
          },
        };
        return {
          productForm: updatedForm,
        };
      });
    }


  }

  handleValidation() {
    if (this.state.formIsValid) {
      return true;
    }

    this.setState((prevState) => {
      let updatedForm = { ...prevState.productForm };
      for (const inputName in prevState.productForm) {
        let isValid = true;
        let errorMessage = "";
        if (
          inputName === "selectedBrand" ||
          inputName === "selectedType" ||
          inputName === "selectedDivision"
        ) {
          for (const validator of prevState.productForm[inputName].validators) {
            isValid =
              isValid &&
              validator(prevState.productForm[inputName].value.value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.productForm[inputName].value.value)
                    .errorMessage
                : errorMessage;
          }
        } else {
          
          for (const validator of prevState.productForm[inputName].validators) {
            isValid =
              isValid &&
              validator(prevState.productForm[inputName].value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.productForm[inputName].value).errorMessage
                : errorMessage;
          }
        }
        updatedForm = {
          ...updatedForm,
          [inputName]: {
            ...updatedForm[inputName],
            valid: isValid,
            errorMessage: errorMessage,
          },
        };
      }
      return {
        productForm: updatedForm,
      };
    });
  }

  productFormHandler() {
    if (this.handleValidation()) {
      ///////

      var postProductData = {
        productIsFake:this.state.productIsFake,
        selectedOrigin:this.state.selectedOrigin,
        description:this.state.description,
        positiveValues:this.state.positiveValues,
        negetiveValues:this.state.negetiveValues,

        selectedBrand:this.state.productForm.selectedBrand.value,
        selectedType:this.state.productForm.selectedType.value,
        model:this.state.productForm.model.value,
        selectedDivision:this.state.productForm.selectedDivision.value,
        persianTitle:this.state.productForm.persianTitle.value,
        englishTitle:this.state.productForm.englishTitle.value,
        package_length:this.state.productForm.package_length.value,
        package_width:this.state.productForm.package_width.value,
        package_height:this.state.productForm.package_height.value,
        package_weight:this.state.productForm.package_weight.value,
      };
      // if (1) {
      this.props.addProductHandler(postProductData);
    }
  }

  positiveTagRemoveHandler(index) {
    var array = [...this.state.positiveValues];
    array.splice(index, 1);
    this.setState({ positiveValues: array });
  }

  negetiveTagRemoveHandler(index) {
    var array = [...this.state.negetiveValues];
    array.splice(index, 1);
    this.setState({ negetiveValues: array });
  }

  addPositiveHandler(event) {
    this.setState({
      positiveValues: [...this.state.positiveValues, this.state.positiveValue],
      positiveValue: "",
    });
  }

  addNegetiveHandler(event) {
    this.setState({
      negetiveValues: [...this.state.negetiveValues, this.state.negetiveValue],
      negetiveValue: "",
    });
  }

  handleBlur(val, event) {
    if (val.target.id === "positive") {
      this.setState({ focusPositive: false });
    } else {
      this.setState({ focusNegetive: false });
    }
  }
  handleFocus(val, event) {
    if (val.target.id === "positive") {
      this.setState({ focusPositive: true });
    } else {
      this.setState({ focusNegetive: true });
    }
  }

  handleSelectChange(event, selector) {
    // if (selector.name === "division") {
    //   this.setState({ selectedDivision: event });
    // }
    // if (selector.name === "type") {
    //   this.setState({ selectedType: event });
    // }
    // if (selector.name === "brand") {
    //   this.setState({ selectedBrand: event });
    // }
    if (selector.name === "origin") {
      this.setState({ selectedOrigin: event });
    }
  }

  handleChange(event) {
    if (event.target.name === "description") {
      let wordCount = event.target.value.trim().length;
      this.setState({ description: event.target.value, wordCount: wordCount });
    }
    if (event.target.id === "positive") {
      this.setState({ positiveValue: event.target.value });
    }
    if (event.target.id === "negetive") {
      this.setState({ negetiveValue: event.target.value });
    }
    // if (event.target.id === "persianTitle") {
    //   this.setState({ persianTitle: event.target.value });
    // }
    // if (event.target.id === "englishTitle") {
    //   this.setState({ englishTitle: event.target.value });
    // }
    // if (event.target.id === "model") {
    //   this.setState({ model: event.target.value });
    // }
    // if (event.target.id === "package_length") {
    //   this.setState({ package_length: event.target.value });
    // }
    // if (event.target.id === "package_width") {
    //   this.setState({ package_width: event.target.value });
    // }
    // if (event.target.id === "package_height") {
    //   this.setState({ package_height: event.target.value });
    // }
    // if (event.target.id === "package_weight") {
    //   this.setState({ package_weight: event.target.value });
    // }
    if (event.target.id === "productIsFake") {
      this.setState({ productIsFake: event.target.checked });
    }
  }

  handleSubmit(event) {
    alert("An essay was submitted: " + this.state.value);
    event.preventDefault();
  }

  ////////////////////////////////////////////////////////////////////////////////////////

  // componentDidUpdate(previousProps, previousState) {
  //   if (previousProps.categoryData !== this.props.categoryData) {
  //     this.FetchBrands(this.props.categoryData.code);
  //     this.FetchDivisions(this.props.categoryData.code);
  //     this.FetchTypes(this.props.categoryData.code);
  //   }
  // }

  FetchBrands = (code) => {
    const graphqlQuery = {
      query: `
            query FetchBrands($categoryCode: Int) {
              brands(categoryCode: $categoryCode){
                code
                title
                enTitle
                imageUrl
                isActive
              }
            }
          `,
      variables: {
        categoryCode: code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت برند!");
        }
        let brandArray = [];
        for (const brand of resData.data.brands) {
          brandArray.push({
            value: brand.code,
            label: brand.title + brand.enTitle,
          });
        }
        this.setState({
          brandOptions: brandArray,
        });
      })
      .catch(this.catchError);
  };
  FetchDivisions = (code) => {
    const graphqlQuery = {
      query: `
            query FetchDivisions($categoryCode: Int) {
              divisions(categoryCode: $categoryCode){
                code
                title
                imageUrl
                isActive
              }
            }
          `,
      variables: {
        categoryCode: code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت برند!");
        }
        let divisionArray = [];
        for (const division of resData.data.divisions) {
          divisionArray.push({
            value: division.code,
            label: division.title,
          });
        }
        this.setState({
          divisionOptions: divisionArray,
        });
      })
      .catch(this.catchError);
  };
  FetchTypes = (code) => {
    const graphqlQuery = {
      query: `
            query FetchTypes($categoryCode: Int) {
              types(categoryCode: $categoryCode){
                code
                title
                imageUrl
                isActive
              }
            }
          `,
      variables: {
        categoryCode: code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت برند!");
        }
        let typeArray = [];
        for (const type of resData.data.types) {
          typeArray.push({
            value: type.code,
            label: type.title,
          });
        }
        this.setState({
          typeOptions: typeArray,
        });
      })
      .catch(this.catchError);
  };

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        productForm: {
          ...prevState.productForm,
          [input]: {
            ...prevState.productForm[input],
            touched: true,
          },
        },
      };
    });
  };

  inputSelectChangeHandler(event, selector) {
    // if (selector.name === "division") {
    //   this.setState({ selectedDivision: event });
    // }
    // if (selector.name === "type") {
    //   this.setState({ selectedType: event });
    // }
    // if (selector.name === "brand") {
    //   this.setState({ selectedBrand: event });
    // }
    if (selector.name === "selectedType") {
      this.setState((prevState) => {
        let isValid = true;
        let errorMessage = "";
        for (const type in event.value) {
          isValid =
            isValid &&
            prevState.productForm[selector.name].validator(type.toString())
              .hasError;
          errorMessage =
            !isValid && errorMessage === ""
              ? prevState.productForm[selector.name].validator(type.toString())
                  .errorMessage
              : errorMessage;
        }
        const updatedForm = {
          ...prevState.productForm,
          [selector.name]: {
            ...prevState.productForm[selector.name],
            valid: isValid,
            value: event,
            errorMessage: errorMessage,
          },
        };
        let formIsValid = true;
        formIsValid = formIsValid && updatedForm[selector.name].valid;

        return {
          productForm: updatedForm,
          formIsValid: formIsValid,
        };
      });
    } else {
      this.setState((prevState) => {
        let isValid = true;
        let errorMessage = "";
        for (const validator of prevState.productForm[selector.name]
          .validators) {
          isValid = isValid && validator(event.value.toString()).hasError;
          errorMessage =
            !isValid && errorMessage === ""
              ? validator(event.value.toString()).errorMessage
              : errorMessage;
        }
        const updatedForm = {
          ...prevState.productForm,
          [selector.name]: {
            ...prevState.productForm[selector.name],
            valid: isValid,
            value: event,
            errorMessage: errorMessage,
          },
        };
        let formIsValid = true;
        for (const inputName in updatedForm) {
          formIsValid = formIsValid && updatedForm[inputName].valid;
        }

        return {
          productForm: updatedForm,
          formIsValid: formIsValid,
        };
      });
    }
  }

  inputChangeHandler(event) {
    // if (event.target.id === "persianTitle") {
    //   this.setState({ persianTitle: event.target.value });
    // }
    // if (event.target.id === "englishTitle") {
    //   this.setState({ englishTitle: event.target.value });
    // }
    // if (event.target.id === "model") {
    //   this.setState({ model: event.target.value });
    // }
    // if (event.target.id === "package_length") {
    //   this.setState({ package_length: event.target.value });
    // }
    // if (event.target.id === "package_width") {
    //   this.setState({ package_width: event.target.value });
    // }
    // if (event.target.id === "package_height") {
    //   this.setState({ package_height: event.target.value });
    // }
    // if (event.target.id === "package_weight") {
    //   this.setState({ package_weight: event.target.value });
    // }
    const val = event.target;
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.productForm[val.id].validators) {
        isValid = isValid && validator(val.value).hasError;
        errorMessage =
          !isValid && errorMessage === ""
            ? validator(val.value).errorMessage
            : errorMessage;
      }
      const updatedForm = {
        ...prevState.productForm,
        [val.id]: {
          ...prevState.productForm[val.id],
          valid: isValid,
          value: val.value,
          errorMessage: errorMessage,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }

      return {
        productForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  }

  catchError = (error) => {
    this.props.errorCatcher.bind(this, error);
  };
 
  render() {
    return (
      <Fragment>
        <div className="mn-card__body mn-card__body--content">
          <form
            className="product-form"
            id="stepProductForm"
            noValidate="novalidate"
            data-select2-id="stepProductForm"
            onSubmit={e => { e.preventDefault(); }}
          >
            {/* <div id="ajaxErrorCategory" className="mn-content-error">
              <p>
                برای فروش کتاب نیاز به بارگذاری "پروانه ناشر یا پروانه نشر
                دیجیتال و یا مجوز کتاب از وزارت ارشاد و فرهنگ اسلامی" دارید
                لطفاً جهت بارگذاری مدرک موردنظر به تب بارگذاری مدارک مراجعه
                ومدرک مورد نیاز را ارسال نمایید.
              </p>
            </div> */}
            <div className="mn-grid__row mn-grid__row--gap-lg">
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12">
                <div className="mn-content-product__auto-title-msg">
                  گروه کالایی انتخاب شده، دارای ویژگی اتوماتیک نامگذاری است و به
                  صورت هوشمند با توجه به ورودی‌های شما در گام‌های اول تا سوم،
                  بهترین عنوان کالایی مطابق با قوانین صحیح را در گام چهارم به
                  شما پیشنهاد می‌دهد. در صورتی که نام‌گذاری از نظر شما تایید شده
                  است، لطفا از کلید "تایید عنوان و ادامه" استفاده کنید؛ در غیر
                  اینصورت با استفاده از کلید "ویرایش عنوان"، عنوان صحیح مدنظر
                  خود را وارد کنید. توجه داشته باشید در صورتی که عنوان ورودی از
                  سمت شما خالی باشد، عنوان پیشنهادی برای عنوان اصلی کالای شما
                  انتخاب خواهد شد.
                </div>
              </div>
            </div>
            <div className="mn-grid__row mn-grid__row--gap-lg">
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12">
                <div className="mn-content-product__selected-category">
                  <div className="mn-content-product__msg mn-content-product__msg--focus">
                    گروه کالایی انتخابی شما{" "}
                    <span id="categoryTitleSpan" className="em">
                      {this.props.categoryData.name}
                    </span>
                    و تنوع مجاز برای این گروه کالایی{" "}
                    <span id="categoryThemeTranslatedSpan" className="em">
                      {dataTheme[this.props.categoryData.dataTheme-1]}
                    </span>
                    است.
                  </div>
                  {this.props.categoryData.isUniformPackaging && (
                    <div
                      id="noteDimensionLevelProduct"
                      className="mn-content-product__msg mn-content-product__msg--focus"
                    >
                      &nbsp;ابعاد بسته‌بندی گروه کالایی{" "}
                      <span name="categoryTitleSpan" className="em">
                        {this.props.categoryData.name}
                      </span>
                      بر اساس <span className="em">محصول</span>
                      است. شما بایستی برای <span className="em">محصول</span>
                      خود در همین گام ابعاد بسته‌بندی وارد کنید.
                    </div>
                  )}
                  {!this.props.categoryData.isUniformPackaging && (
                    <div
                      id="noteDimensionLevelItem"
                      className="mn-content-product__msg mn-content-product__msg--focus"
                    >
                      &nbsp;ابعاد بسته‌بندی گروه کالایی{" "}
                      <span name="categoryTitleSpan" className="em">
                        {this.props.categoryData.name}
                      </span>
                      بر اساس <span className="em">تنوع</span>
                      است. شما بایستی برای هر <span className="em">تنوع</span>
                      در صفحه ایجاد تنوع (مرحله بعدی)، ابعاد بسته‌بندی را وارد
                      کنید.
                    </div>
                  )}
                  <div
                    className="mn-content-product__msg"
                    id="categoryThemeDescriptionSpan"
                  >
                    <strong>
                      تنوع {dataTheme[this.props.categoryData.dataTheme-1]}:{" "}
                    </strong>
                    {dataThemeInfo[this.props.categoryData.dataTheme-1]}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="mn-grid__row mn-grid__row--gap-lg"
              data-select2-id="242"
            >
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-4 mn-grid__col--xs-gap">
                <label htmlFor="productIsFake" className="uk-form-label">
                  اصالت کالا:
                </label>
                <div className="mn-field-wrapper mn-field-wrapper--background">
                  <label className="mn-ui-checkbox--container">
                    <input
                      type="checkbox"
                      className="mn-ui-checkbox__checkbox"
                      name="productIsFake"
                      id="productIsFake"
                      value="1"
                      onChange={this.handleChange}
                      checked={this.state.productIsFake}
                    />
                    <span className="mn-ui-checkbox__checkmark"></span>
                    <span className="mn-ui-checkbox__label">
                      نشان کالای غیراصل(
                      <span className="mn-ui-checkbox__strong">غیر اصل</span>)
                    </span>
                  </label>
                </div>
              </div>
              <div
                className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-4 mn-grid__col--xs-gap"
                data-select2-id="241"
              >
                <label
                  htmlFor=""
                  className="uk-form-label uk-flex uk-flex-between"
                >
                  برند یا نام سازنده کالا:{" "}
                  <span className="uk-form-label__required"></span>
                  {/* <a href="#" className="search-link" id="newBrandRequestModalBtn">درخواست برند جدید</a> */}
                </label>
                <div
                  className={[
                    "field-wrapper",
                    this.state.productForm["selectedBrand"].errorMessage === ""
                      ? ""
                      : "has-error",
                  ].join(" ")}
                >
                  <Select
                    name="selectedBrand"
                    control="input"
                    // value={this.state.productForm.selectedBrand}
                    options={this.state.brandOptions}
                    theme={colourStyles.theme}
                    onChange={this.inputSelectChangeHandler}
                    onBlur={this.inputBlurHandler.bind(this, "selectedBrand")}
                    value={this.state.productForm["selectedBrand"].value}
                    valid={this.state.productForm["selectedBrand"].valid}
                    touched={this.state.productForm["selectedBrand"].touched}
                  />
                  <div id={2} className="error error-msg">
                    {this.state.productForm["selectedBrand"].errorMessage}
                  </div>
                </div>
              </div>
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-4">
                <div></div>
              </div>
            </div>
            <div className="mn-grid__row mn-grid__row--gap-lg">
              <div
                className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-4 "
                data-select2-id="239"
              >
                <label
                  htmlFor=""
                  className="uk-form-label uk-flex uk-flex-between"
                >
                  نوع کالا: <span className="uk-form-label__required"></span>
                </label>
                <div
                  className={[
                    "field-wrapper",
                    this.state.productForm["selectedType"].errorMessage === ""
                      ? ""
                      : "has-error",
                  ].join(" ")}
                >
                  
                  <Select
                    control="input"
                    // defaultValue={console.log(this.state.productForm["selectedType"].value)}
                    isMulti
                    name="selectedType"
                    options={this.state.typeOptions}
                    styles={colourStyles}
                    theme={colourStyles.theme}
                    onChange={this.inputSelectChangeHandler}
                    onBlur={this.inputBlurHandler.bind(this, "selectedType")}
                    value={this.state.productForm["selectedType"].value}
                    valid={this.state.productForm["selectedType"].valid}
                    touched={this.state.productForm["selectedType"].touched}
                  />
                  <div id={2} className="error error-msg">
                    {this.state.productForm["selectedType"].errorMessage}
                  </div>
                </div>
              </div>
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-4 mn-grid__col--xs-gap js-product-model">
                <label htmlFor="" className="uk-form-label">
                  مدل کالا: <span className="uk-form-label__required"></span>
                </label>
                <div
                  className={[
                    "field-wrapper",
                    this.state.productForm["model"].errorMessage === ""
                      ? ""
                      : "has-error",
                  ].join(" ")}
                >
                  <input
                    name="model"
                    id="model"
                    type="text"
                    placeholder="مدل کالا را وارد کنید …"
                    value={this.state.productForm.model.value}
                    className="mn-content-input__origin"
                    onChange={this.inputChangeHandler}
                  />
                  <div id={2} className="error error-msg">
                    {this.state.productForm["model"].errorMessage}
                  </div>
                </div>
                <div></div>
              </div>
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-4 mn-grid__col--xs-gap js-divisions-select">
                <label
                  htmlFor=""
                  className="uk-form-label uk-flex uk-flex-between"
                >
                  دسته‌بندی کالا:{" "}
                  <span className="uk-form-label__required"></span>
                </label>
                <div
                  className={[
                    "field-wrapper",
                    this.state.productForm["selectedDivision"].errorMessage ===
                    ""
                      ? ""
                      : "has-error",
                  ].join(" ")}
                >
                  <Select
                    name="selectedDivision"
                    control="input"
                    value={this.state.productForm.selectedDivision}
                    options={this.state.divisionOptions}
                    theme={colourStyles.theme}
                    onChange={this.inputSelectChangeHandler}
                    onBlur={this.inputBlurHandler.bind(
                      this,
                      "selectedDivision"
                    )}
                    value={this.state.productForm["selectedDivision"].value}
                    valid={this.state.productForm["selectedDivision"].valid}
                    touched={this.state.productForm["selectedDivision"].touched}
                  />
                  <div id={2} className="error error-msg">
                    {this.state.productForm["selectedDivision"].errorMessage}
                  </div>
                </div>
              </div>
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial o-spacing-m-t-4 mn-grid__col--sm-4 ">
                <label
                  htmlFor=""
                  className="uk-form-label uk-flex uk-flex-between"
                >
                  مبدا کالا:
                </label>
                {/* <div
                  className={[
                    "field-wrapper",
                    this.state.productForm["origin"].errorMessage === ""
                      ? ""
                      : "has-error",
                  ].join(" ")}
                > */}
                <Select
                  name="origin"
                  control="input"
                  value={this.state.selectedOrigin}
                  options={origin}
                  theme={colourStyles.theme}
                  onChange={this.handleSelectChange}
                  // onBlur={this.inputBlurHandler.bind(this, "origin")}
                  // value={this.state.productForm["origin"].value}
                  // valid={this.state.productForm["origin"].valid}
                  // touched={this.state.productForm["origin"].touched}
                />
                {/* <div id={2} className="error error-msg">
                    {this.state.productForm["origin"].errorMessage}
                  </div>
                </div> */}
              </div>
              <div className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial o-spacing-m-t-4 c-grid__col--sm-4 c-grid__col--xs-gap js-product-className-select">
                <div></div>
              </div>
            </div>
            <div className="mn-grid__row mn-grid__row--gap-lg js-step-product-title">
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6">
                <label htmlFor="" className="uk-form-label">
                  نام فارسی کالا:{" "}
                  <span className="uk-form-label__required"></span>
                </label>
                <div
                  className={[
                    "field-wrapper",
                    this.state.productForm["persianTitle"].errorMessage === ""
                      ? ""
                      : "has-error",
                  ].join(" ")}
                >
                  <input
                    id="persianTitle"
                    type="text"
                    placeholder="ماهیت کالا + برند + کلمه مدل+مدل کالا"
                    className="mn-content-input__origin"
                    value={this.state.productForm.persianTitle.value}
                    name="product[title_fa]"
                    onChange={this.inputChangeHandler}
                    required=""
                  />
                  <div id={2} className="error error-msg">
                    {this.state.productForm["persianTitle"].errorMessage}
                  </div>
                </div>
                <div></div>
              </div>
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6 mn-grid__col--xs-gap">
                <label htmlFor="" className="uk-form-label">
                  نام انگلیسی کالا:
                </label>
                <div
                  className={[
                    "field-wrapper",
                    this.state.productForm["englishTitle"].errorMessage === ""
                      ? ""
                      : "has-error",
                  ].join(" ")}
                >
                  <input
                    id="englishTitle"
                    type="text"
                    placeholder="Enter the name of your item in the following order: Brand + Model + Nature of the Product"
                    className="mn-content-input__origin"
                    value={this.state.productForm.englishTitle.value}
                    name="product[title_en]"
                    onChange={this.inputChangeHandler}
                    required=""
                  />
                  <div id={2} className="error error-msg">
                    {this.state.productForm["englishTitle"].errorMessage}
                  </div>
                </div>
                <div></div>
              </div>
            </div>
            <div className="mn-grid__row mn-grid__row--gap-lg js-product-package-dimension">
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-8 ">
                <div className="mn-grid__row mn-grid__row--gap-lg mn-grid__row--nowrap-sm">
                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6">
                    <label htmlFor="" className="uk-form-label">
                      ابعاد بسته‌بندی (سانتیمتر):{" "}
                      <span className="uk-form-label__required"></span>
                    </label>
                    <div className="mn-grid__row mn-grid__row--gap-small mn-grid__row--nowrap-sm">
                      <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial">
                        <div
                          className={[
                            "field-wrapper",
                            this.state.productForm["package_length"]
                              .errorMessage === ""
                              ? ""
                              : "has-error",
                          ].join(" ")}
                        >
                          <label className="mn-content-input">
                            {" "}
                            <span className="mn-content-input__text mn-content-input__text--overlay">
                              طول
                            </span>
                            <input
                              id="package_length"
                              type="text"
                              placeholder=""
                              className="mn-content-input__origin mn-content-input__origin--overlay"
                              value={this.state.productForm.package_length.value}
                              onChange={this.inputChangeHandler}
                              name="product[package_length]"
                            />
                          </label>
                          <div id={2} className="error error-msg">
                            {
                              this.state.productForm["package_length"]
                                .errorMessage
                            }
                          </div>
                        </div>
                      </div>
                      <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                        <div
                          className={[
                            "field-wrapper",
                            this.state.productForm["package_width"]
                              .errorMessage === ""
                              ? ""
                              : "has-error",
                          ].join(" ")}
                        >
                          <label className="mn-content-input">
                            {" "}
                            <span className="mn-content-input__text mn-content-input__text--overlay">
                              عرض
                            </span>
                            <input
                              id="package_width"
                              type="text"
                              placeholder=""
                              className="mn-content-input__origin mn-content-input__origin--overlay"
                              value={this.state.productForm.package_width.value}
                              onChange={this.inputChangeHandler}
                              name="product[package_width]"
                            />
                          </label>
                          <div id={2} className="error error-msg">
                            {
                              this.state.productForm["package_width"]
                                .errorMessage
                            }
                          </div>
                        </div>
                      </div>
                      <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                        <div
                          className={[
                            "field-wrapper",
                            this.state.productForm["package_height"]
                              .errorMessage === ""
                              ? ""
                              : "has-error",
                          ].join(" ")}
                        >
                          <label className="mn-content-input">
                            {" "}
                            <span className="mn-content-input__text mn-content-input__text--overlay">
                              ارتفاع
                            </span>
                            <input
                              id="package_height"
                              type="text"
                              placeholder=""
                              className="mn-content-input__origin mn-content-input__origin--overlay"
                              value={this.state.productForm.package_height.value}
                              onChange={this.inputChangeHandler}
                              name="product[package_height]"
                            />
                          </label>
                          <div id={2} className="error error-msg">
                            {
                              this.state.productForm["package_height"]
                                .errorMessage
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6 mn-grid__col--xs-gap">
                    <label htmlFor="" className="uk-form-label">
                      وزن بسته بندی (گرم):{" "}
                      <span className="uk-form-label__required"></span>
                    </label>
                    <div
                      className={[
                        "field-wrapper",
                        this.state.productForm["package_weight"]
                          .errorMessage === ""
                          ? ""
                          : "has-error",
                      ].join(" ")}
                    >
                      <label className="mn-content-input">
                        {" "}
                        <span className="mn-content-input__text mn-content-input__text--overlay">
                          وزن
                        </span>
                        <input
                          id="package_weight"
                          type="text"
                          placeholder=""
                          className="mn-content-input__origin mn-content-input__origin--overlay"
                          value={this.state.productForm.package_weight.value}
                          onChange={this.inputChangeHandler}
                          name="package_weight"
                        />
                      </label>
                      <div id={2} className="error error-msg">
                        {this.state.productForm["package_weight"].errorMessage}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mn-grid__row mn-grid__row--gap-lg">
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial">
                <label htmlFor="" className="uk-form-label">
                  شرح کالا:
                </label>
                <div className="field-wrapper field-wrapper--textarea">
                  <textarea
                    name="description"
                    placeholder="برای معرفی بهتر کالا به مشتریان، پیشنهاد می‌‌شود 150 کلمه درباره‌ کالای خود بنویسید."
                    className="mn-content-input__origin mn-content-input__origin--textarea js-textarea-words"
                    rows="5"
                    maxLength="2000"
                    value={this.state.description}
                    onChange={this.handleChange}
                  ></textarea>
                  <span className="textarea__wordcount">
                    <span className="js-wordcount-target">
                      {this.state.wordCount}
                    </span>
                    /2000
                  </span>
                </div>
              </div>
            </div>
            <div className="mn-grid__row mn-grid__row--gap-lg">
              <div className="mn-grid__col mn-grid__col--gap-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                <label htmlFor="" className="uk-form-label">
                  نقاط قوت:
                </label>
                <div className="field-wrapper field-wrapper--textarea">
                  <div
                    className={[
                      "mn-ui-tag__textarea mn-ui-tag__textarea--inline",
                      this.state.focusPositive ? "focus" : "",
                    ].join(" ")}
                  >
                    <input
                      id="positive"
                      type="text"
                      className="mn-ui-tag__input mn-ui-tag__input--inline"
                      value={this.state.positiveValue}
                      onChange={this.handleChange}
                      onFocus={this.handleFocus.bind(this)}
                      onBlur={this.handleBlur.bind(this)}
                    />
                    <button
                      type="button"
                      className="mn-ui-tag__submit"
                      onClick={this.addPositiveHandler.bind(this)}
                    >
                      +
                    </button>
                  </div>
                  <div className="mn-ui-tag__textarea js-textarea-tags-container">
                    {this.state.positiveValues.map((data, index) => {
                      return (
                        <span key={index} className="mn-ui-tag__label">
                          {data}
                          <span
                            className="mn-ui-tag__remove"
                            onClick={this.positiveTagRemoveHandler.bind(
                              this,
                              index
                            )}
                          ></span>
                        </span>
                      );
                    })}
                  </div>
                </div>
                <div></div>
              </div>

              <div className="mn-grid__col mn-grid__col--gap-attr mn-grid__col--flex-initial mn-grid__col--sm-6 mn-grid__col--xs-gap">
                <label htmlFor="" className="uk-form-label">
                  نقات ضعف:
                </label>
                <div className="field-wrapper field-wrapper--textarea">
                  <div
                    className={[
                      "mn-ui-tag__textarea mn-ui-tag__textarea--inline",
                      this.state.focusNegetive ? "focus" : "",
                    ].join(" ")}
                  >
                    <input
                      id="negetive"
                      type="text"
                      className="mn-ui-tag__input mn-ui-tag__input--inline"
                      value={this.state.negetiveValue}
                      onChange={this.handleChange}
                      onFocus={this.handleFocus.bind(this)}
                      onBlur={this.handleBlur.bind(this)}
                    />
                    <button
                      type="button"
                      className="mn-ui-tag__submit"
                      onClick={this.addNegetiveHandler.bind(this)}
                    >
                      +
                    </button>
                  </div>
                  <div className="mn-ui-tag__textarea">
                    {this.state.negetiveValues.map((data, index) => {
                      return (
                        <span className="mn-ui-tag__label">
                          {data}
                          <span
                            className="mn-ui-tag__remove"
                            onClick={this.negetiveTagRemoveHandler.bind(
                              this,
                              index
                            )}
                          ></span>
                        </span>
                      );
                    })}
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </form>
        </div>
        {/* <div className="mn-content-accordion__step-controls">
          <button
            type="button"
            className="mn-ui-btn mn-ui-btn--next mr-a"
            id="productStepNext"
            onClick={this.productFormHandler.bind(this)}
          >
            ادامه دادن
          </button>
        </div> */}
      </Fragment>
    );
  }
}

export default ProductData;
